import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

import { SgKdConstants } from '../../../../../sg-kd-shared/sg-kd-constants';

@Component({
  selector: 'app-sgkd002d-sms',
  templateUrl: './sgkd002d-sms.component.html',
  styleUrl: './sgkd002d-sms.component.scss'
})
export class Sgkd002dSmsComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  @Input() mainForm: UntypedFormGroup;

  /** ＳＭＳ決済フォーム */
  smsForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd002dSmsComponent
   */
  ngOnInit(): void {
    this.smsForm = this.createSmsForm();
    this.mainForm.addControl("smsForm", this.smsForm);
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd002dSmsComponent
   */
  ngOnDestroy(): void {
    this.mainForm.removeControl("smsForm");
    this.onDestroy$.next();
  }

  /**
   * ＳＭＳ決済フォームの生成
   * 
   * @returns - ＳＭＳ決済フォーム
   * @memberof Sgkd002dSmsComponent
   */
  private createSmsForm(): UntypedFormGroup {
    return this.formBuilder.group({
      // 携帯電話番号
      cellphonenumber: new UntypedFormControl(
        { value: '', disabled: false },
        [
          Validators.required,
          Validators.maxLength(SgKdConstants.SGKD002D.MAX_LENGTH.CELLPHONENUMBER),
          Validators.pattern(SgKdConstants.PATTERN.TEL_NO)
        ]
      ),
    });
  }
}
